export function preencheReducoesAutomaticamente(selectedOption, campoReducaoIbs, campoReducaoCbs, mostrarNotificacao = true) {
  if (!selectedOption || !selectedOption.value) {
    return;
  }

  const percentualReducaoIbs = selectedOption.dataset.percentualReducaoIbs;
  const percentualReducaoCbs = selectedOption.dataset.percentualReducaoCbs;
  
  let preencheuAlgumCampo = false;
  
  if (campoReducaoIbs && percentualReducaoIbs) {
    campoReducaoIbs.value = formata_numero(parseFloat(percentualReducaoIbs));
    campoReducaoIbs.dispatchEvent(new Event('change', { bubbles: true }));
    campoReducaoIbs.dispatchEvent(new Event('input', { bubbles: true }));
    preencheuAlgumCampo = true;
  }
  
  if (campoReducaoCbs && percentualReducaoCbs) {
    campoReducaoCbs.value = formata_numero(parseFloat(percentualReducaoCbs));
    campoReducaoCbs.dispatchEvent(new Event('change', { bubbles: true }));
    campoReducaoCbs.dispatchEvent(new Event('input', { bubbles: true }));
    preencheuAlgumCampo = true;
  }

  if (preencheuAlgumCampo && mostrarNotificacao) {
    exibe_mensagem_com_status(
      'Preenchemos os percentuais de acordo com as informações da SEFAZ, alterações podem ser realizadas sob o risco de rejeição',
      'warning'
    );
  }
}

export async function atualizaClassificacoesTributarias(situacaoTributariaSelect, classificacaoTributariaSelect) {
  if (!situacaoTributariaSelect || !classificacaoTributariaSelect) {
    return;
  }

  const situacaoTributariaId = situacaoTributariaSelect.value;

  if (!situacaoTributariaId) {
    limpaSelectClassificacao(classificacaoTributariaSelect);
    return;
  }

  classificacaoTributariaSelect.disabled = true;

  const configClassificacoesTributarias = await capturaConfiguracoesTributariasJSON(situacaoTributariaId);
  if (!configClassificacoesTributarias) return;
  limpaSelectClassificacao(classificacaoTributariaSelect);

  configClassificacoesTributarias.forEach(classificacao => {
    const option = document.createElement('option');
    option.value = classificacao.id;
    option.text = classificacao.codigo_com_nome;
    option.dataset.percentualReducaoIbs = classificacao.percentual_reducao_ibs || '';
    option.dataset.percentualReducaoCbs = classificacao.percentual_reducao_cbs || '';
    classificacaoTributariaSelect.appendChild(option);
  });

  classificacaoTributariaSelect.disabled = false;
}

function limpaSelectClassificacao(selectElement) {
  selectElement.innerHTML = '';
  const optionPrompt = document.createElement('option');
  optionPrompt.value = '';
  optionPrompt.text = 'Selecione a Classificação Tributária';
  selectElement.appendChild(optionPrompt);
}

Object.assign(globalThis, {
  atualizaClassificacoesTributarias
});
